import { get } from './apiService';

const financeService = {
  getSummary: async () => {
    return get('admin/finances/summary', { withCredentials: false });
  },
};

export default financeService;
